<template>
    <div class="pa-3">
        <div>
            <span class="text-capitalize font-weight-bold">{{$t('projectName')}}</span>:
            {{project.name}}
            <v-icon small class="ml-3">edit</v-icon>
        </div>
        <div><span class="text-capitalize font-weight-bold">{{$t('createdDate')}}</span>:
            {{project.created_time | formatDateTime}}
        </div>
        <v-btn @click="deleteProject">Delete Project</v-btn>
    </div>
</template>
<script>
import ProjectService from '@/services/project.service'

export default {
    name: 'ProjectDetails',
    data () {
        return {
            projectId: this.$route.params.project_id,
            project: {}
        }
    },
    mounted () {
        this.getProject()
        this.$store.dispatch(this.$actionTypes.LOADING, false)
    },
    methods: {
        deleteProject () {
            this.$store.dispatch(this.$actionTypes.LOADING, true)
            ProjectService.deleteProject(this.projectId).then(result => {
                this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, '')
                this.$store.dispatch(this.$actionTypes.user.GET_PROJECTS)
                this.$store.dispatch(this.$actionTypes.LOADING, false)
                this.$router.push('/getting-started')
            }).catch(err => {
                this.$store.dispatch(this.$actionTypes.LOADING, false)
                console.log(err)
            })
        },
        async getProject () {
            await ProjectService.getProjectById(this.projectId).then(res => {
                this.project = res.data
            }).catch(error => {
                console.log(error)
                this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, '')
                // this.$router.push('/404')
            })
        }
    }
}
</script>
